import { Component, OnInit } from '@angular/core';
import { AppservicesService } from '../services/appservices.service';
import * as echarts from 'echarts';
import { ModalController } from '@ionic/angular';
import { CompanyComponent } from '../company/company.component';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import { NewcompanyComponent } from '../newcompany/newcompany.component';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {

  today=Date.now();

  dashboarddata=[];
  listcompanyies=[];
  listapps=[];
  /** for providing graphics **/
  
  constructor(public dialog: MatDialog,private appserv:AppservicesService, private modal:ModalController) { }

  ngOnInit() {
    this.dashboarddata=this.appserv.dashboardData();
    this.listcompanyies=this.appserv.companyiesdata();
    this.listapps=this.appserv.getlistapps();

    this.getfirstgraphic();
  }

 
  openDialog2(enterAnimationDuration?: string, exitAnimationDuration?: string) {
    const dialogRef = this.dialog.open(NewcompanyComponent,{
      width: '100%',
      enterAnimationDuration,
      exitAnimationDuration,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  async getfirstgraphic(){

      type EChartsOption = echarts.EChartsOption;
      var chartDom = document.getElementById('firstgraphic')!;
      var myChart = echarts.init(chartDom);
      var option: EChartsOption; 
      
        /** providing graphics */
        option = {
          tooltip: {
            trigger: 'item'
          },
          legend: {
            top: '5%',
            left: 'center'
          },
          series: [
            {
              name: 'Access From',
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'left'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '40',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: [
                { value: 1048, name: 'Search Engine' },
                { value: 735, name: 'Direct' },
                { value: 580, name: 'Email' },
                { value: 484, name: 'Union Ads' },
                { value: 300, name: 'Video Ads' }
              ]
            }
          ]
        };
  
    option && myChart.setOption(option);
  }

  async seconfgraphic(){

      var ROOT_PATH = 'https://echarts.apache.org/examples';

      var chartDom = document.getElementById('secondgraphic');
      var myChart = echarts.init(chartDom);
      var option;

      const weatherIcons = {
        Sunny: ROOT_PATH + '/data/asset/img/weather/sunny_128.png',
        Cloudy: ROOT_PATH + '/data/asset/img/weather/cloudy_128.png',
        Showers: ROOT_PATH + '/data/asset/img/weather/showers_128.png'
      };
      option = {
        title: {
          text: 'Weather Statistics',
          subtext: 'Fake Data',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          bottom: 10,
          left: 'center',
          data: ['CityA', 'CityB', 'CityD', 'CityC', 'CityE']
        },
        series: [
          {
            type: 'pie',
            radius: '65%',
            center: ['50%', '50%'],
            selectedMode: 'single',
            data: [
              {
                value: 1548,
                name: 'CityE',
                label: {
                  formatter: [
                    '{title|{b}}{abg|}',
                    '  {weatherHead|Weather}{valueHead|Days}{rateHead|Percent}',
                    '{hr|}',
                    '  {Sunny|}{value|202}{rate|55.3%}',
                    '  {Cloudy|}{value|142}{rate|38.9%}',
                    '  {Showers|}{value|21}{rate|5.8%}'
                  ].join('\n'),
                  backgroundColor: '#eee',
                  borderColor: '#777',
                  borderWidth: 1,
                  borderRadius: 4,
                  rich: {
                    title: {
                      color: '#eee',
                      align: 'center'
                    },
                    abg: {
                      backgroundColor: '#333',
                      width: '100%',
                      align: 'right',
                      height: 25,
                      borderRadius: [4, 4, 0, 0]
                    },
                    Sunny: {
                      height: 30,
                      align: 'left',
                      backgroundColor: {
                        image: weatherIcons.Sunny
                      }
                    },
                    Cloudy: {
                      height: 30,
                      align: 'left',
                      backgroundColor: {
                        image: weatherIcons.Cloudy
                      }
                    },
                    Showers: {
                      height: 30,
                      align: 'left',
                      backgroundColor: {
                        image: weatherIcons.Showers
                      }
                    },
                    weatherHead: {
                      color: '#333',
                      height: 24,
                      align: 'left'
                    },
                    hr: {
                      borderColor: '#777',
                      width: '100%',
                      borderWidth: 0.5,
                      height: 0
                    },
                    value: {
                      width: 20,
                      padding: [0, 20, 0, 30],
                      align: 'left'
                    },
                    valueHead: {
                      color: '#333',
                      width: 20,
                      padding: [0, 20, 0, 30],
                      align: 'center'
                    },
                    rate: {
                      width: 40,
                      align: 'right',
                      padding: [0, 10, 0, 0]
                    },
                    rateHead: {
                      color: '#333',
                      width: 40,
                      align: 'center',
                      padding: [0, 10, 0, 0]
                    }
                  }
                }
              },
              { value: 735, name: 'CityC' },
              { value: 510, name: 'CityD' },
              { value: 434, name: 'CityB' },
              { value: 335, name: 'CityA' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };

      option && myChart.setOption(option);
  }

  async addnewcompany(){
    const modal=this.modal.create({
      component:CompanyComponent
    });

    ((await modal).present())
  } 
}
